// extracted by css-extract-rspack-plugin
export default {"shareWrapper":"_223af5df","socialIcon":"_c7a97631 _ff04910a","shareIcon":"_63cbad07 _ff04910a","white":"_cc1ee9a6"};